import React from "react";

type SkeletonVariant =
  | "text"
  | "line"
  | "title"
  | "avatar"
  | "rect"
  | "card"
  | "shimmer";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  height?: string | number;
  noAnimate?: boolean;
  shimmer?: boolean;
  variant?: SkeletonVariant;
  width?: string | number;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  className = "",
  height,
  noAnimate = false,
  shimmer = false,
  style,
  variant = "line",
  width,
  ...props
}) => {
  const classes = [
    "fg-skeleton",
    variant,
    shimmer ? "shimmer" : "",
    noAnimate ? "no-animate" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const inlineStyle = {
    height: typeof height === "number" ? `${height}px` : height,
    width: typeof width === "number" ? `${width}px` : width,
    ...style,
  };

  return (
    <div
      aria-hidden="true"
      className={classes}
      style={inlineStyle}
      {...props}
    />
  );
};
